export function toBooleanString(b) {
	return b === true || b === "true" ? "TRUE" : "FALSE";
}
